<template>
	<div>
		<NavHeader/>
		<div class="main-header-content">
			<div class="container">
				<h3>FREQUENTLY ASKED QUESTIONS</h3>
			</div>
		</div>

		<div class="divider"></div>
		<div class="container">
			<div class="information-detail">
				<privacy-sidebar />
				<div class="information-content">
					<h6 class="info-header">Basic Information</h6>
					<div class="faq-content">
						<h6 class="question-header">1. What is eRemit for Business?</h6>

						<p class="content-para">e-Remit for business  is an online secure global money transfer service offered by Merchantrade Asia Sdn Bhd to facilitate international commercial payments for businesses.  It also includes international payments from companies to individuals.
						</p>
					</div>

					<div class="faq-content">
						<h6 class="question-header">2. Who is eligible to use e-Remit for business?</h6>
						<p class="content-para">Any company and enterprise registered under Companies Commission Malaysia (SSM).</p>
					</div>
					<h6 class="info-header">Registration Process</h6>
					<div class="faq-content">
						<h6 class="question-header">1. How do I/we create an account with eRemit for Business?</h6>

						<p class="content-para">
							Please visit www.eremit.com.my, click on the “For Business” button, to Sign up and upload the relevant identification documents.
						</p>
						<p class="content-para">
							For Enterprises : -Sole Proprietorships /Partnerships
						</p>
						<ul class="faq-list faq-list-tick">
							<li>Form D - Certificate of Registration</li>
							<li>NRIC/Passport Copy of Authorised Person to access the online portal to perform transactions on behalf of the enterprise. (minimum two persons is required)</li>
							<li>Owner's/Partners NRIC Copy</li>
							<li>Letter of Authorisation (in the Company's Letter Head)</li>
						</ul>
						<p class="content-para">
							For Private Limited Companies(Sdn Bhd)
						</p>
						<ul class="faq-list faq-list-tick">
							<li>NRIC/Passport Copy of Directors or Key Responsible Person</li>
							<li>Letter of Authorisation (in the Company's Letter Head) </li>
							<li>Form 49</li>
							<li>Memorandum & Article of Association (M&A)</li>
							<li>Form 24</li>
							<li>Form 9 - Certificate of Incorporation</li>
							<li>NRIC/Passport Copy of Authorised Person to access the online portal to perform transactions on behalf of the company. (minimum two persons is required)</li>
						</ul>
					</div>

					<div class="faq-content">
						<h6 class="question-header">2. Why do I/we need to submit company incorporation documents and MyKad or Passport of Authorised Persons and directors? </h6>
						<p class="content-para">
							Identification Documents (ID) are necessary for verification in accordance with the Company’s standard Customer Due Diligence process and regulatory requirements.
						</p>
					</div>
					<h6 class="info-header">Transaction Process</h6>
					<div class="faq-content">
						<h6 class="question-header">1. How can I/we send money?</h6>
						<p class="content-para">
							Registered authorised person (s) of the company to login to the business account to create a beneficiary profile, enter bank details and make the transfer.
						</p>
					</div>
					<div class="faq-content">
						<h6 class="question-header">2. When can I/we perform transaction(s)?</h6>
						<p class="content-para">You can perform transactions with us from Mondays to Fridays from 9am - 6pm and on Saturdays from 9am - 1pm. (except Sundays and Public Holidays)
						</p>
					</div>
					<div class="faq-content">
						<h6 class="question-header">3. Can anyone from my/our company perform transaction(s)? </h6>
						<p class="content-para">Only registered authorised person (s) of the business account can perform transactions.
						</p>
					</div>

					<div class="faq-content">
						<h6 class="question-header">4. Are there any charges imposed on the beneficiary for e-Remit for business?</h6>
						<p class="content-para">No charges will be imposed on the beneficiary except for transfer effected via SWIFT as the correspondent banks may deduct a handling fee, therefore your beneficiary may receive the transfer amount less the SWIFT charges.
						</p>
					</div>
					<div class="faq-content">
						<h6 class="question-header">5. What is the exchange rate applicable for my/our transaction(s)?</h6>
						<p class="content-para">The exchange rate will be the displayed rate at the point of your confirmation of transaction. This rate will be reflected on the remittance receipt. 
						</p>
					</div>
					<div class="faq-content">
						<h6 class="question-header">6. How does my/our company make the payment to Merchantrade?</h6>
						<ul class="faq-list faq-list-tick">
						<li>On-line bank transfer to Merchantrade’s bank account by selecting your preferred bank business account and authorise your payment through FPX payment gateway 
							Note: FPX is a convenient and secure online payment solution that allows real-time debiting of customer's internet banking account of multiple banks</li>
						<li>Non On-line bank transfer via Rentas or cheque payment to Merchantrade ‘s bank account</li>
						<p class="note">Note: Payment to Merchantrade must be from the registered company’s own bank account.</p>
					</ul>
					</div>
					<div class="faq-content">
						<h6 class="question-header">7. What are the available modes of payment to the beneficiary? </h6>
						<p class="content-para">Bank account credit to the beneficiary via Bank transfer or SWIFT
						</p>
					</div>
					<div class="faq-content">
						<h6 class="question-header">8. Can I/we amend or cancel transaction(s)?</h6>
						<p class="content-para">Amendments or cancellations can only be done if the transaction has not been paid or credited into the beneficiary’s account. Kindly contact our Customer Care Consultants immediately.
						</p>
						<p class="note">Note: Merchantrade Asia Sdn Bhd shall not be responsible for any Payout to the wrong person or entity arising from any erroneous data input by the Sender.</p>
					</div>
					<div class="faq-content">
						<h6 class="question-header">9. Do I/we have to enter the beneficiary’s details every time I/we make the transfer?</h6>
						<p class="content-para">eRemit for Business captures and retains particulars of your beneficiaries. However, you can make changes to beneficiary's particulars prior to authorising the payment
						</p>
						
					</div>
					<div class="faq-content">
						<h6 class="question-header">10. How do I/we check the status of the company’s transaction(s)?</h6>
						<p class="content-para">The transaction status can be viewed on “Transaction History” page.
						</p>
					</div>
					<div class="faq-content">
						<h6 class="question-header">11. Do I/we get a receipt for the company’s transactions?</h6>
						<p class="content-para">A remittance receipt will be issued and can be downloaded at the Transaction History page 
						</p>
					</div>
					<div class="faq-content">
						<h6 class="question-header">12. When will the beneficiary receive the funds and what is your service charges?</h6>
						<p class="content-para">Please refer to our <a href="javascript:void(0)">Delivery Time and Service Charges</a>
						</p>
					</div>
					<div class="faq-content">
						<h6 class="question-header">13. Why is the transfer to the beneficiary unsuccessful and funds returned?</h6>
						<p class="content-para">The most common reasons are incorrect details (e.g. account number and name of beneficiary) submitted on the payment details.  You will be notified when the funds are returned to us, you can either request the transfer to be reprocessed or refunded. The amount returned from the beneficiary’s bank may not be the full amount due to deduction of bank charges. The amount to be refunded to you will be less bank charges and our service charge.
						</p>
					</div>
					<h6 class="info-header">Transfer Amount Limit</h6>
					<div class="faq-content">
						<h6 class="question-header">1. How much can the company send?</h6>
						<p class="content-para">The online business remittance service is subject to the maximum allowable limit as determined by the regulator or Merchantrade’s internal policy.
						</p>
					</div>
					<h6 class="info-header">Contacts & Operation Hours</h6>
					<div class="faq-content">
						<h6 class="question-header">1. How can I contact the Customer Care Consultants?</h6>
						
						<p class="content-para">We're open from 9am to 6pm daily including public holidays.</p>
						
						<p class="content-para">
							<img src="/static/commercial/img/icons/01call.png" alt="" class="contact-icons">
							<a href="tel:+60383138606">Tel +603-8313 8606 & +603-7724 2070 & +6013-368 8606</a>
						</p>

						<p class="content-para">
							<img src="/static/commercial/img/icons/01fax.png" alt="" class="contact-icons">
							<a href="fax:+60377241811">Fax +6 03 7724 1811</a>
						</p>

						<p class="content-para">
							<img src="/static/commercial/img/icons/01mail.png" alt="" class="contact-icons">
							<a href="mailto:customercare@eremit.com.my">bizcare@eremit.com.my</a>
						</p>
					</div>
				</div>
			</div>
		</div>
		<div class="divider"></div>
	</div>
</template>

<script>
	import DownloadApp from "../../shared/commercial/DownloadApp.vue";
	import NavHeader from "../../shared/commercial/NavHeader.vue";
	import PrivacySidebar from "../../components/privacysidebar.vue"
	import SignUpFooter from "../../shared/commercial/SignUpFooter.vue";
	export default {
		name: 'faq',
		components: { DownloadApp, NavHeader, SignUpFooter, PrivacySidebar },
	}
</script>